import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Button, CircularProgress } from "@mui/material";
import styles from "./changeOrgModal.module.scss";
import { useAppSelector } from "src/page/store";

interface Iprops {
  handleClose: () => void;
  onConfirm: () => void;
}

function ChangeOrgModal({ handleClose, onConfirm }: Iprops) {
  const { switchOrgLoading } = useAppSelector((state) => state.auth);

  if (switchOrgLoading) {
    return (
      <div className={styles.progress}>
        <CircularProgress sx={{ color: "#0f172a" }} size={36} />
        <p className={styles.progressLabel}>Switching account…</p>
      </div>
    );
  }

  return (
    <div className={styles.modal}>
      <div className={styles.iconWrap}>
        <SwapHorizIcon />
      </div>
      <p className={styles.body}>You are about to be redirected to the client&apos;s view of their account.</p>
      <div className={styles.actions}>
        <Button className={styles.cancelBtn} variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button className={styles.confirmBtn} variant="contained" onClick={onConfirm}>
          Switch
        </Button>
      </div>
    </div>
  );
}

export default ChangeOrgModal;
